import state from './state';

export default {
    getRateTables() {
      return state.rateTables;
    },

    getTotalPages() {
      return state.totalPage;
    },

    getTotal() {
      return state.totalItems;
    },

    getRateTable() {
      return state.rateTable;
    },

    getActiveRateId() {
      return state.activeRateId;
    },

    getActiveRate() {
      return state.rateTable.rates ? state.rateTable.rates[state.activeRateId] : {};
    },

    getRates() {
      return state.rateTable.rates;
    }
}